import { Input } from '@bitcine/cinesend-theme/dist'

const AssetIdentifier = ({ asset }) => {
  return <Input label={'Asset Identifier'} value={asset.uuid} disabled={true} />
}

export default AssetIdentifier
